// Módulos Angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, LOCALE_ID } from '@angular/core';
import { registerLocaleData, CommonModule } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
registerLocaleData(localeBr, 'pt');

import { AuthInterceptor } from './auth.interceptor';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';

// Módulos diversos
import { AppRoutingModule } from './app-routing.module';

//Shared
import { ListboxComponent } from './components/shared/listbox/listbox.component';
import { PriceSelectionComponent  } from './components/shared/price-selection/price-selection.component';

// Módulos Bootstrap
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

// Módulos Telerik
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';

// Serviços
import { DbService } from './db.service';
import { SessionService } from './session.service';
import { RelatoriosService } from './services/relatorios.service';
import { SpinnerService } from './spinner.service';

// MasterPage
import { AppComponent } from './components/app/app.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { AppLoginModalComponent } from './components/app-login/app-login.component';

import { PesquisaSalarialAssinaturaComponent } from './components/sobre-salariometro/planos/pesquisa-salarial/pesquisa-salarial-assinatura.component';

// Demais componentes
import { AreaAssinanteComponent } from './components/area-assinante/area-assinante.component';
import { HomeComponent } from './components/home/home.component';
import { Home_AssinaturaComponent } from './components/home/_assinatura.component';
import { Home_BannerComponent } from './components/home/_banner.component';
import { Home_BoletinsComponent } from './components/home/_boletins.component';
import { Home_ContatoComponent } from './components/home/_contato.component';
import { Home_ConteudosComponent } from './components/home/_conteudos.component';
import { Home_IndicacaoAmigoComponent } from './components/home/_indicacao-amigo.component';
import { Home_NoticiasComponent } from './components/home/_noticias.component';

import { SolicitacoesEspeciaisComponent } from './components/solicitacoes-especiais/solicitacoes-especiais.component';
import { SolicitacoesEspeciaisBloqueioAssinaturaComponent } from './components/solicitacoes-especiais/bloqueio-assinatura/bloqueio-assinatura.component';
import { NegociacaoColetivaCompletaDemoComponent } from './components/negociacao-coletiva-completa-demo/negociacao-coletiva-completa-demo.component';
import { NegociacaoColetivaCompletaComponent } from './components/negociacao-coletiva-completa/negociacao-coletiva-completa.component';
import { NegociacaoColetivaCompletaBloqueioAssinaturaComponent } from './components/negociacao-coletiva-completa/bloqueio-assinatura/bloqueio-assinatura.component';
import { NegociacaoColetivaSimplificadaDemoComponent } from './components/negociacao-coletiva-simplificada-demo/negociacao-coletiva-simplificada-demo.component';
import { NegociacaoColetivaSimplificadaComponent } from './components/negociacao-coletiva-simplificada/negociacao-coletiva-simplificada.component';
import { NegociacaoColetivaSimplificadaBloqueioAssinaturaComponent } from './components/negociacao-coletiva-simplificada/bloqueio-assinatura/bloqueio-assinatura.component';
import { NegociacaoColetivaPremiumDemoComponent } from './components/negociacao-coletiva-premium-demo/negociacao-coletiva-premium-demo.component';
import { NegociacaoColetivaPremiumComponent } from './components/negociacao-coletiva-premium/negociacao-coletiva-premium.component';
import { NegociacaoColetivaPremiumBloqueioAssinaturaComponent } from './components/negociacao-coletiva-premium/bloqueio-assinatura/bloqueio-assinatura.component';
import { PesquisaSalarialDemoComponent } from './components/pesquisa-salarial-demo/pesquisa-salarial-demo.component';
import { PesquisaSalarialComponent } from './components/pesquisa-salarial/pesquisa-salarial.component';
import { PesquisaSalarialBloqueioAssinaturaComponent } from './components/pesquisa-salarial/bloqueio-assinatura/bloqueio-assinatura.component';
import { PesquisaSalarialSHDemoComponent } from './components/pesquisa-salarial-sh-demo/pesquisa-salarial-demo.component';
import { PesquisaSalarialSHComponent } from './components/pesquisa-salarial-sh/pesquisa-salarial-sh.component';
import { PesquisaSalarialSHBloqueioAssinaturaComponent } from './components/pesquisa-salarial-sh/bloqueio-assinatura/bloqueio-assinatura-sh.component';
import { BoletimComponent } from './components/boletim/boletim.component';
import { BoletimBloqueioAssinaturaComponent } from './components/boletim/bloqueio-assinatura/bloqueio-assinatura.component';

import { Sobre_MetodologiaComponent } from './components/sobre-salariometro/metodologia/metodologia.component';
import { Sobre_PlanosComponent } from './components/sobre-salariometro/planos/planos.component';
import { Sobre_QuemSomosComponent } from './components/sobre-salariometro/quem-somos/quem-somos.component';
import { PrecosComponent } from './components/sobre-salariometro/precos/precos.component';
import { NotFound404Component } from './components/not-found-404/not-found-404.component';
import { EmConstrucaoComponent } from './components/em-construcao/em-construcao.component';

// Pipes
import { FirstErrorPipe } from './first-error.pipe';
import { MunicipioFilterPipe } from './components/sobre-salariometro/planos/municipio-filter.pipe';
import { AppRecuperarSenhaComponent } from './components/app-recuperar-senha/app-recuperar-senha.component';
import { CopyrightAlertComponent } from './components/shared/copyright-alert/copyright-alert.component';

@NgModule({
    declarations: [
        AppComponent,
        AppHeaderComponent,
        AppFooterComponent,
        AppLoginModalComponent,
        PesquisaSalarialAssinaturaComponent,
        ListboxComponent,
        PriceSelectionComponent,
        AppRecuperarSenhaComponent,
        AreaAssinanteComponent,
        HomeComponent,
        Home_AssinaturaComponent,
        Home_BannerComponent,
        Home_BoletinsComponent,
        Home_ContatoComponent,
        Home_ConteudosComponent,
        Home_IndicacaoAmigoComponent,
        Home_NoticiasComponent,
        SolicitacoesEspeciaisComponent,
        SolicitacoesEspeciaisBloqueioAssinaturaComponent,
        NegociacaoColetivaCompletaDemoComponent,
        NegociacaoColetivaCompletaComponent,
        NegociacaoColetivaCompletaBloqueioAssinaturaComponent,
        NegociacaoColetivaSimplificadaDemoComponent,
        NegociacaoColetivaSimplificadaComponent,
        NegociacaoColetivaSimplificadaBloqueioAssinaturaComponent,
        NegociacaoColetivaPremiumDemoComponent,
        NegociacaoColetivaPremiumComponent,
        NegociacaoColetivaPremiumBloqueioAssinaturaComponent,
        PesquisaSalarialBloqueioAssinaturaComponent,
        PesquisaSalarialDemoComponent,
        PesquisaSalarialComponent,
        PesquisaSalarialSHBloqueioAssinaturaComponent,
        PesquisaSalarialSHDemoComponent,
        PesquisaSalarialSHComponent,
        BoletimComponent,
        BoletimBloqueioAssinaturaComponent,
        Sobre_MetodologiaComponent,
        Sobre_PlanosComponent,
        Sobre_QuemSomosComponent,
        PrecosComponent,
        NotFound404Component,
        EmConstrucaoComponent,
        FirstErrorPipe,
        MunicipioFilterPipe,
        CopyrightAlertComponent,
        OtpVerificationComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        CarouselModule.forRoot(),
        ModalModule.forRoot(),
        ScrollToModule.forRoot(),
        DialogsModule,
        DropDownsModule,
        InputsModule,
        LayoutModule,
        CommonModule 
    ],
    providers: [
        DbService,
        SessionService,
        RelatoriosService,
        SpinnerService,
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ],
    entryComponents: [
        CopyrightAlertComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
